const MIME = Object.freeze({
  json: 'application/json',
  text: 'text/plain',
});

// noinspection JSUnusedGlobalSymbols
export default MIME;
